import React, { useState, useRef, useEffect } from 'react';

function ComboBox({ value, options, on_change, className }) {
	const [open, set_open] = useState(false);
	const container_ref = useRef(null);

	useEffect(function() {
		function handle_click_outside(e) {
			if(container_ref.current && !container_ref.current.contains(e.target)) {
				set_open(false);
			}
		}
		document.addEventListener('mousedown', handle_click_outside);
		return function() { document.removeEventListener('mousedown', handle_click_outside); };
	}, []);

	return (
		<div ref={container_ref} style={{ position: 'relative' }}>
			<div style={{ display: 'flex' }}>
				<input
					type="text"
					className={className}
					value={value || ''}
					onChange={function(e) { on_change(e.target.value); set_open(true); }}
					onFocus={function() { set_open(true); }}
					style={{ borderRadius: open ? '4px 0 0 4px' : '4px 0 0 4px', flex: 1 }}
				/>
				<button
					type="button"
					onClick={function() { set_open(function(prev) { return !prev; }); }}
					style={{
						border: '1px solid #555',
						borderLeft: 'none',
						background: '#2a2a2a',
						color: '#ccc',
						padding: '0 10px',
						borderRadius: '0 4px 4px 0',
						cursor: 'pointer',
					}}>
					&#9660;
				</button>
			</div>
			{open && (
				<ul style={{
					position: 'absolute',
					top: '100%',
					left: 0,
					right: 0,
					background: '#2a2a2a',
					border: '1px solid #555',
					borderRadius: '0 0 4px 4px',
					margin: 0,
					padding: 0,
					listStyle: 'none',
					zIndex: 1000,
					maxHeight: 200,
					overflowY: 'auto',
				}}>
					{options.map(function(opt) {
						return (
							<li
								key={opt}
								onMouseDown={function() { on_change(opt); set_open(false); }}
								style={{
									padding: '8px 12px',
									cursor: 'pointer',
									color: '#eee',
									backgroundColor: opt === value ? '#3a3a3a' : 'transparent',
								}}
								onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = '#3a3a3a'; }}
								onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = opt === value ? '#3a3a3a' : 'transparent'; }}>
								{opt}
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
}

export default ComboBox;
